import LandingPagesCarouselSlide from './LandingPagesCarouselSlide';

export default class LandingPagesCarouselResponse {
  constructor(
    public status: number,
    public data: LandingPagesCarouselSlide[],
    public error?: Error
  ) {}
}
